import ImageCropDialog from './ImageCropDialog';

export function getRadianAngle(degreeValue: number) {
  return (degreeValue * Math.PI) / 180;
}

export const rotateSize = (width: number, height: number, rotation: number) => {
  const rotRad = getRadianAngle(rotation);

  return {
    width:
      Math.abs(Math.cos(rotRad) * width) + Math.abs(Math.sin(rotRad) * height),
    height:
      Math.abs(Math.sin(rotRad) * width) + Math.abs(Math.cos(rotRad) * height),
  };
};

const fileToDataUrl = (file: File) =>
  new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });

const CropImageModal = ({
  open,
  onClose,
  imageToUpload,
  crop,
  setCrop,
}: any) => {
  const aspect = crop?.aspect ?? 1;

  const handleConfirm = async (file: File) => {
    const data = await file.arrayBuffer();
    const url = await fileToDataUrl(file);
    setCrop((actual: any) => ({
      ...actual,
      image: { data, url },
    }));
  };

  if (!imageToUpload) {
    return null;
  }

  return (
    <ImageCropDialog
      open={open}
      sourceFile={imageToUpload}
      aspect={aspect}
      title="Kép metszése"
      onClose={onClose}
      onConfirm={handleConfirm}
    />
  );
};

export default CropImageModal;
